import React, { ComponentState, useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router";
import { useSelector } from "react-redux";
import { ClientService } from "src/services/clientService";
import APP_ROUTES from "src/helper/app-routes";
import { renderErrors } from "src/helper/error-message-helper";
import NotificationManager from "react-notifications/lib/NotificationManager";

import { NichqHeader } from "./Nichq-heads";
import ClientQuestionnaireService from "./functionToSaveQuestionnaireFromPortal";






export const MFQQuestionnaire = ({ MFQ, response, interfered, isPrint, questionId, isFromCP, queId, token }) => {
  const { state } = useLocation();
  const selectedClientId = useSelector((state: ComponentState) => state.selectedClientId);
  const navigate = useNavigate();

  const [mfq, setMfq] = useState<any[]>([]);

  const handleSaveFromPortal = async () => {
    ClientQuestionnaireService.updatequestionnaireFromPortal(selectedClientId, 0, [...mfq], queId, token)
  }

  const handleCompleteFromPortal = async () => {
    try {
      ClientQuestionnaireService.completeQuestionnaireFromPortal(false, queId, selectedClientId, 0, [...mfq],  {isCompleted: true, inProgress: false, sentToClientPortal: null}, token)
    } catch (error) {
      console.error('Error completing client questionnaire:', error);
      NotificationManager.error('Failed to complete client questionnaire');
    }
  };


    const handleSubmit = async () => {
      await ClientService.insertClientQuestionnaire(
        selectedClientId, 0,
        [
          ...mfq,
        ],
        questionId
      )
        .then((result:any) => {
          let questionList = result.resultData;
          navigate(APP_ROUTES.QUESTIONNAIRE);
          NotificationManager.success("Add successfully");
        })
        .catch((error) => {
          // setLoading(false);
          renderErrors(error.message);
        });
    };


  useEffect(() => {

    const Mfq = MFQ.map((item) => {
      const foundItem = response.find((i) => i.questionId === item.questionId);
      if (foundItem) {
        if (item.type === "question") {
          if (foundItem.value) {
            return { ...item, isSelected: true, value: foundItem.value };
          } else {
            return { ...item, isSelected: false, value: "" };
          }
        }
        return { ...item, ...foundItem };
      } else {
        return item;
      }
    });


    setMfq(Mfq);





  }, [response])

  return (
    <div className="ml-3">

      <div className="mt-5 head-4">
        MOOD AND FEELINGS QUESTIONNAIRE: Long Version 
      </div>

      <div className="row mt-4">
        <p className="mt-2">
           This form is about how you might have been feeling or acting <b>recently.</b>
        </p>
        <p>
          For each question, please select a radio based on how you have been feeling or acting <b>in the past two weeks.</b>
        </p>
        <p >
          If a sentence was not true about you, check NOT TRUE. <br></br>
          If a sentence was only sometimes true, check SOMETIMES. <br></br>
          If a sentence was true about you most of the time, check TRUE. 
        </p>
      </div>


      {
        mfq.length > 0 &&
        <div className="row">
          <NichqHeader

            title={""}
            disabled={isFromCP ? false : (response && response.length>0)}
            subTitle={''}
            listItems={mfq}
            setListItems={setMfq}
          />
        </div>
      }

{isFromCP ? (
          <div className="text-start mt-3 col-12">
           <button onClick={handleCompleteFromPortal} className="submitButon">
            Save & Complete
          </button>
          <button onClick={handleSaveFromPortal} className="cancelBtn">
            Save progress
          </button>
          </div>
        ) : state == null && !isPrint ? (
          <div className="text-start mt-3 col-12">
            <button onClick={handleSubmit} className="submitButon">
              Submit
            </button>
          </div>
        ) : null}


    </div>

  )

}



